export default __webpack_public_path__ + "static/media/kapolka.f42a8206.jpg";